import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import './Present.css';

function TDeposito({ usuario }) {
    const [depositos, setDepositos] = useState([]);
    const [sucursales, setSucursales] = useState([]);
    const [cuentasContables, setCuentasContables] = useState([]);
    const [formulario, setFormulario] = useState({
        idDeposito: '',
        nomDepto: '',
        cuenta: '',
        reserva: 'N',
        estado: 'A',
        idSucursal: ''
    });
    const [modoEdicion, setModoEdicion] = useState(false);
    const [mostrarModal, setMostrarModal] = useState(false);
    const [errores, setErrores] = useState({});
    const [busqueda, setBusqueda] = useState('');
    const [busquedaSucursal, setBusquedaSucursal] = useState('');
    const [busquedaCuenta, setBusquedaCuenta] = useState('');

    useEffect(() => {
        cargarDepositos();
        cargarSucursales();
        cargarCuentasImputables();
    }, []);

    const cargarDepositos = async () => {
        try {
            const response = await axios.get('/api/depositos');
            setDepositos(response.data);
        } catch (error) {
            console.error('Error al cargar depósitos:', error);
            alert('Error al cargar los depósitos');
        }
    };

    const cargarSucursales = async () => {
        try {
            const response = await axios.get('/api/sucursales');
            setSucursales(response.data);
        } catch (error) {
            console.error('Error al cargar sucursales:', error);
            alert('Error al cargar las sucursales');
        }
    };

    const cargarCuentasImputables = async () => {
        try {
            const response = await axios.get('/api/cuentas/imputables');
            setCuentasContables(response.data);
        } catch (error) {
            console.error('Error al cargar cuentas imputables:', error);
            alert('Error al cargar las cuentas contables');
        }
    };

    const validarFormulario = () => {
        const nuevosErrores = {};

        // Validar ID Depósito
        if (!formulario.idDeposito) {
            nuevosErrores.idDeposito = 'El ID del depósito es requerido';
        } else if (isNaN(formulario.idDeposito) || formulario.idDeposito <= 0) {
            nuevosErrores.idDeposito = 'El ID debe ser un número positivo';
        }

        // Validar Nombre Depósito
        if (!formulario.nomDepto.trim()) {
            nuevosErrores.nomDepto = 'El nombre del depósito es requerido';
        } else if (formulario.nomDepto.trim().length > 25) {
            nuevosErrores.nomDepto = 'El nombre no puede tener más de 25 caracteres';
        }

        // Validar Sucursal
        if (!formulario.idSucursal) {
            nuevosErrores.idSucursal = 'Debe seleccionar una sucursal';
        }

        // Validar Reserva
        if (!formulario.reserva) {
            nuevosErrores.reserva = 'Debe seleccionar una opción para Reserva';
        } else if (formulario.reserva !== 'S' && formulario.reserva !== 'N') {
            nuevosErrores.reserva = 'El valor de Reserva debe ser Sí (S) o No (N)';
        }

        // Validar Estado
        if (!formulario.estado) {
            nuevosErrores.estado = 'Debe seleccionar un estado';
        } else if (formulario.estado !== 'A' && formulario.estado !== 'I') {
            nuevosErrores.estado = 'El estado debe ser A (Activo) o I (Inactivo)';
        }

        // Verificar duplicados solo al crear
        if (!modoEdicion) {
            const duplicado = depositos.find(d => d.idDeposito === parseInt(formulario.idDeposito));
            if (duplicado) {
                nuevosErrores.idDeposito = 'Ya existe un depósito con ese ID';
            }
        }

        setErrores(nuevosErrores);
        return Object.keys(nuevosErrores).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormulario(prev => ({
            ...prev,
            [name]: value
        }));

        // Limpiar error del campo que se está editando
        if (errores[name]) {
            setErrores(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validarFormulario()) {
            return;
        }

        try {
            const datosEnviar = {
                idDeposito: parseInt(formulario.idDeposito),
                nomDepto: formulario.nomDepto.trim(),
                cuenta: formulario.cuenta.trim() || null,
                reserva: formulario.reserva,
                estado: formulario.estado,
                idSucursal: parseInt(formulario.idSucursal)
            };

            if (modoEdicion) {
                await axios.put(`/api/depositos/${formulario.idDeposito}`, datosEnviar);
                alert('Depósito actualizado exitosamente');
            } else {
                await axios.post('/api/depositos', datosEnviar);
                alert('Depósito creado exitosamente');
            }

            cerrarModal();
            cargarDepositos();
        } catch (error) {
            console.error('Error al guardar depósito:', error);
            alert('Error al guardar el depósito: ' + (error.response?.data?.mensaje || error.message));
        }
    };

    const handleEditar = (deposito) => {
        setFormulario({
            idDeposito: deposito.idDeposito.toString(),
            nomDepto: deposito.nomDepto,
            cuenta: deposito.cuenta || '',
            reserva: deposito.reserva || 'N',
            estado: deposito.estado,
            idSucursal: deposito.idSucursal?.toString() || ''
        });
        setModoEdicion(true);
        setMostrarModal(true);
        setErrores({});
        setBusquedaSucursal('');
        setBusquedaCuenta('');
    };

    const handleEliminar = async (idDeposito) => {
        if (window.confirm(`¿Está seguro de eliminar el depósito ${idDeposito}?`)) {
            try {
                await axios.delete(`/api/depositos/${idDeposito}`);
                alert('Depósito eliminado exitosamente');
                cargarDepositos();
            } catch (error) {
                console.error('Error al eliminar depósito:', error);
                alert('Error al eliminar el depósito');
            }
        }
    };

    const abrirModalNuevo = () => {
        setFormulario({
            idDeposito: '',
            nomDepto: '',
            cuenta: '',
            reserva: 'N',
            estado: 'A',
            idSucursal: ''
        });
        setModoEdicion(false);
        setMostrarModal(true);
        setErrores({});
        setBusquedaSucursal('');
        setBusquedaCuenta('');
    };

    const cerrarModal = () => {
        setMostrarModal(false);
        setFormulario({
            idDeposito: '',
            nomDepto: '',
            cuenta: '',
            reserva: 'N',
            estado: 'A',
            idSucursal: ''
        });
        setModoEdicion(false);
        setErrores({});
        setBusquedaSucursal('');
        setBusquedaCuenta('');
    };

    const exportarExcel = () => {
        const datosExportar = depositosFiltrados.map(deposito => ({
            'ID Depósito': deposito.idDeposito,
            'Nombre': deposito.nomDepto,
            'Sucursal': obtenerNombreSucursal(deposito.idSucursal),
            'Cuenta': deposito.cuenta,
            'Reserva': deposito.reserva,
            'Estado': deposito.estado === 'A' ? 'Activo' : 'Inactivo'
        }));

        const ws = XLSX.utils.json_to_sheet(datosExportar);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Depositos');
        XLSX.writeFile(wb, 'depositos.xlsx');
    };

    const depositosFiltrados = depositos.filter(deposito =>
        deposito.idDeposito.toString().includes(busqueda) ||
        deposito.nomDepto.toLowerCase().includes(busqueda.toLowerCase()) ||
        obtenerNombreSucursal(deposito.idSucursal).toLowerCase().includes(busqueda.toLowerCase())
    );

    const sucursalesFiltradas = sucursales.filter(sucursal =>
        sucursal.nombre.toLowerCase().includes(busquedaSucursal.toLowerCase()) ||
        sucursal.idSucursal.toString().includes(busquedaSucursal)
    );

    const cuentasFiltradas = cuentasContables.filter(cuenta =>
        cuenta.cuenta.toLowerCase().includes(busquedaCuenta.toLowerCase()) ||
        cuenta.descripcion.toLowerCase().includes(busquedaCuenta.toLowerCase())
    );

    const obtenerNombreSucursal = (idSucursal) => {
        const sucursal = sucursales.find(s => s.idSucursal === idSucursal);
        return sucursal ? sucursal.nombre : `ID: ${idSucursal}`;
    };

    const obtenerDescripcionCuenta = (cuenta) => {
        const cta = cuentasContables.find(c => c.cuenta === cuenta);
        return cta ? `${cta.cuenta} - ${cta.descripcion}` : cuenta;
    };

    const obtenerTextoReserva = (reserva) => {
        return reserva === 'S' ? 'Sí' : reserva === 'N' ? 'No' : '-';
    };

    const obtenerEstadoTexto = (estado) => {
        return estado === 'A' ? 'Activo' : 'Inactivo';
    };

    const obtenerEstadoColor = (estado) => {
        return estado === 'A' ? '#27ae60' : '#e74c3c';
    };

    return (
        <div className="present-container">
            <div className="header-seccion">
                <h2>Gestión de Depósitos</h2>
                <div className="acciones-header">
                    <input
                        type="text"
                        className="input-busqueda"
                        placeholder="Buscar depósito..."
                        value={busqueda}
                        onChange={(e) => setBusqueda(e.target.value)}
                    />
                    <button className="btn btn-nuevo" onClick={abrirModalNuevo}>
                        ➕ Nuevo Depósito
                    </button>
                    <button className="btn btn-exportar" onClick={exportarExcel}>
                        📊 Exportar a Excel
                    </button>
                </div>
            </div>

            <div className="tabla-container">
                <table className="tabla-datos">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre</th>
                            <th>Sucursal</th>
                            <th>Cuenta</th>
                            <th>Reserva</th>
                            <th>Estado</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {depositosFiltrados.length > 0 ? (
                            depositosFiltrados.map(deposito => (
                                <tr key={deposito.idDeposito}>
                                    <td>{deposito.idDeposito}</td>
                                    <td>{deposito.nomDepto}</td>
                                    <td>{obtenerNombreSucursal(deposito.idSucursal)}</td>
                                    <td>{deposito.cuenta ? obtenerDescripcionCuenta(deposito.cuenta) : '-'}</td>
                                    <td>{obtenerTextoReserva(deposito.reserva)}</td>
                                    <td>
                                        <span style={{
                                            color: obtenerEstadoColor(deposito.estado),
                                            fontWeight: 'bold'
                                        }}>
                                            {obtenerEstadoTexto(deposito.estado)}
                                        </span>
                                    </td>
                                    <td>
                                        <button
                                            className="btn-accion"
                                            onClick={() => handleEditar(deposito)}
                                            title="Editar"
                                        >
                                            ✏️
                                        </button>
                                        <button
                                            className="btn-accion"
                                            onClick={() => handleEliminar(deposito.idDeposito)}
                                            title="Eliminar"
                                        >
                                            🗑️
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" className="sin-datos">
                                    No se encontraron depósitos
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <div className="footer-tabla">
                Total de depósitos: {depositosFiltrados.length}
            </div>

            {mostrarModal && (
                <div className="modal-overlay">
                    <div className="modal-contenido">
                        <div className="modal-header">
                            <h3>{modoEdicion ? 'Editar Depósito' : 'Nuevo Depósito'}</h3>
                            <button className="btn-cerrar" onClick={cerrarModal}>×</button>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>ID Depósito *</label>
                                <input
                                    type="number"
                                    name="idDeposito"
                                    className={`form-input ${errores.idDeposito ? 'form-input-error' : ''}`}
                                    value={formulario.idDeposito}
                                    onChange={handleChange}
                                    disabled={modoEdicion}
                                    placeholder="Ingrese el ID del depósito"
                                />
                                {errores.idDeposito && <span className="form-error">{errores.idDeposito}</span>}
                            </div>

                            <div className="form-group">
                                <label>Nombre del Depósito *</label>
                                <input
                                    type="text"
                                    name="nomDepto"
                                    className={`form-input ${errores.nomDepto ? 'form-input-error' : ''}`}
                                    value={formulario.nomDepto}
                                    onChange={handleChange}
                                    maxLength="25"
                                    placeholder="Ingrese el nombre del depósito"
                                />
                                {errores.nomDepto && <span className="form-error">{errores.nomDepto}</span>}
                            </div>

                            <div className="form-group">
                                <label>Sucursal *</label>
                                <input
                                    type="text"
                                    className="form-input"
                                    placeholder="Buscar sucursal..."
                                    value={busquedaSucursal}
                                    onChange={(e) => setBusquedaSucursal(e.target.value)}
                                    style={{ marginBottom: '5px' }}
                                />
                                <select
                                    name="idSucursal"
                                    className={`form-input ${errores.idSucursal ? 'form-input-error' : ''}`}
                                    value={formulario.idSucursal}
                                    onChange={handleChange}
                                    size="5"
                                    style={{ height: '120px' }}
                                >
                                    <option value="">Seleccione una sucursal...</option>
                                    {sucursalesFiltradas.map(sucursal => (
                                        <option key={sucursal.idSucursal} value={sucursal.idSucursal}>
                                            {sucursal.idSucursal} - {sucursal.nombre}
                                        </option>
                                    ))}
                                </select>
                                {errores.idSucursal && <span className="form-error">{errores.idSucursal}</span>}
                            </div>

                            <div className="form-group">
                                <label>Cuenta Contable (Imputable)</label>
                                <input
                                    type="text"
                                    className="form-input"
                                    placeholder="Buscar cuenta..."
                                    value={busquedaCuenta}
                                    onChange={(e) => setBusquedaCuenta(e.target.value)}
                                    style={{ marginBottom: '5px' }}
                                />
                                <select
                                    name="cuenta"
                                    className="form-input"
                                    value={formulario.cuenta}
                                    onChange={handleChange}
                                    size="5"
                                    style={{ height: '120px' }}
                                >
                                    <option value="">Ninguna (opcional)</option>
                                    {cuentasFiltradas.map(cuenta => (
                                        <option key={cuenta.cuenta} value={cuenta.cuenta}>
                                            {cuenta.cuenta} - {cuenta.descripcion}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="form-group">
                                <label>Reserva *</label>
                                <select
                                    name="reserva"
                                    className={`form-input ${errores.reserva ? 'form-input-error' : ''}`}
                                    value={formulario.reserva}
                                    onChange={handleChange}
                                >
                                    <option value="S">Sí</option>
                                    <option value="N">No</option>
                                </select>
                                {errores.reserva && <span className="form-error">{errores.reserva}</span>}
                            </div>

                            <div className="form-group">
                                <label>Estado *</label>
                                <select
                                    name="estado"
                                    className={`form-input ${errores.estado ? 'form-input-error' : ''}`}
                                    value={formulario.estado}
                                    onChange={handleChange}
                                >
                                    <option value="A">Activo</option>
                                    <option value="I">Inactivo</option>
                                </select>
                                {errores.estado && <span className="form-error">{errores.estado}</span>}
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-cancelar" onClick={cerrarModal}>
                                    Cancelar
                                </button>
                                <button type="submit" className="btn btn-guardar">
                                    {modoEdicion ? 'Actualizar' : 'Guardar'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default TDeposito;
